import {CheckHealthRequest} from "./check-health-request";
import {AwpDmsInterfaceFactoryUtils} from "../../rest-api/awp-dms-interface-factory-utils";

export class AwpDmsInterfaceCheckHealthRequestFactory {
  createCheckHealthRequest(locale: string, dpNo: string, outletNo: string): CheckHealthRequest {
    const schema = 'awp-dms-check-health-request';
    const version = '1.0.0';
    const req = new CheckHealthRequest();
    req.functionalHeader = AwpDmsInterfaceFactoryUtils.createFunctionalHeaderFromPrimitives(dpNo, outletNo);
    req.technicalHeader = AwpDmsInterfaceFactoryUtils.createTechnicalHeaderInRequest(schema, version);
    req.userInformation = AwpDmsInterfaceFactoryUtils.createUserInformationFromPrimitive(locale);
    return req;
  }
}
